/* eslint-disable */
import React, { useEffect, useState } from "react";
import "./styles.scss";
import GetAppIcon from "@mui/icons-material/GetApp";
import { Box, IconButton, Tooltip } from "@mui/material";
import Moment from "moment";
import { connect, useDispatch } from "react-redux";
import { Link, useSearchParams } from "react-router-dom";
import {
  clearRental,
  clearRentalsData,
  finishRent,
  getFinallyDataOfRental,
  getRentalById,
  getRentals,
  getRentalsStatuses,
  rentalsDockList,
  rentalsUserList,
  rentalsVehiclesList,
  updateRental,
} from "../../actions/rentals";
import {
  emptyPassedParams,
  setFilterValue,
  setSearchValue,
} from "../../actions/screen";
import {
  getLinkedStationsByCity,
  getStationsByCity,
  getStationsOnMap,
} from "../../actions/stations";
import InputDialogWithMap from "../../components/dialog/inputDialogWithMap";
import RentalFilter from "../../components/dialog/rentalFilter";
import { RentalsExportBox } from "../../components/exportBox/RentalsExportBox";
import RentalsItem from "../../components/items/rentalsItem";
import Loader from "../../components/loader";
import ImagePreviewModal from "../../components/modal/ImagePreviewModal";
import RentalModal from "../../components/modal/rentalModal";
import SearchBlockWithRefreshBtn from "../../components/table/searchBlockWithRefreshBtn";
import { DASHBOARD_RENTALS_GALLERY } from "../../constants/routes";
import { useDebounce, useShowToast } from "../../hooks";
import { strings } from "../../I18n";
import { reformatFilter, reformatSearch } from "../../utils/utils";

function RentalsContainer(props) {
  const {
    orderProps,
    changePage,
    searchValue,
    changeSearch,
    clearSearchValue,
    rentalByIdSuccess,
    finishRent,
    rentalsVehiclesList,
    getStationsByCity,
    rentalsDockList,
    rentalsUserList,
    updateRentalSuccess,
    clearRental,
    getRentals,
    filterProps,
    postFinishRentalSuccess,
    pageSize,
    rentalsStatusesSuccess,
    getRentalsStatuses,
    clearRentalsData,
    rentalsStatuses,
    citiesList,
    getFinallyDataOfRental,
    finallyRentalData,
    getFinallyRentalData,
    getRentalsSuccess,
    savedCity,
    getLinkedStationsByCity,
    passedParams,
    emptyPassedParams,
    getRentalById,
    currentPageValue,
    getStationsOnMap,
    orderValue,
  } = props;

  const searchDataOptions = [
    { value: "rentId", label: "rentId" },
    { value: "username", label: "username" },
    { value: "userId", label: "userId" },
    { value: "bikeName", label: "bikeName" },
    { value: "startStationName", label: "startStationName" },
    { value: "endStationName", label: "endStationName" },
    { value: "startDockCode", label: "startDockCode" },
    { value: "endDockCode", label: "endDockCode" },
    { value: "duration", label: "duration" },
  ];

  const [finishRentDialogVisibility, setFinishRentDialogVisibility] =
    React.useState(false);
  const [filterVisible, setFilterVisible] = React.useState(false);
  const [rentals, setRentals] = React.useState(props.rentals);
  const [showExport, setShowExport] = useState(false);
  const [filterValues, setFilterValues] = React.useState([]);
  const [selectedRentalUser, setSelectedRentalUser] = useState();
  const [currentRentStartTime, setCurrentRentStartTime] = useState(null);
  const [imagePreviewModal, setImagePreviewModal] = useState(false);
  const [previewImageUrls, setPreviewImageUrls] = useState([]);
  const [searchFilter, setSearchFilter] = useState();

  const debouncedSearchTerm = useDebounce(searchValue, 1000);
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (searchParams.has("search")) {
      dispatch(setSearchValue(searchParams.get("search")));
      searchParams.delete("search");
      setSearchParams(searchParams);
    }

    const filter = searchDataOptions.find((item) =>
      searchParams.has(item.value)
    );
    if (filter) {
      setSearchFilter(filter);
      dispatch(setSearchValue(searchParams.get(filter.value)));
      searchParams.delete(filter.value);
      setSearchParams(searchParams);
    }
  }, []);

  useEffect(() => {
    setRentals(props.rentals);
  }, [props.rentals]);

  useEffect(() => {
    if (rentalByIdSuccess) {
      rentalsVehiclesList();
      getLinkedStationsByCity(null);
      getStationsByCity(null);
      rentalsDockList(null);
      rentalsUserList(selectedRentalUser);
      getRentalsStatuses();
    }
  }, [
    rentalByIdSuccess,
    rentalsVehiclesList,
    getStationsByCity,
    rentalsDockList,
    rentalsUserList,
    getLinkedStationsByCity,
    getRentalsStatuses,
    selectedRentalUser,
  ]);

  useEffect(() => {
    if (filterProps?.filterValue) {
      setFilterValues(filterProps?.filterValue || []);
    }
  }, [filterProps]);

  useEffect(() => {
    if (passedParams) {
      getRentalById(passedParams);
      emptyPassedParams();
    }
  }, [passedParams, getRentalById, emptyPassedParams]);

  useEffect(() => {
    if (updateRentalSuccess) {
      showToast("Rent updated.", "success");
      clearRental();
      reloadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateRentalSuccess, clearRental, savedCity]);

  useEffect(() => {
    if (postFinishRentalSuccess) {
      clearRental();
      reloadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postFinishRentalSuccess, clearRental, getRentals, savedCity]);

  useEffect(() => {
    if (getFinallyRentalData) {
      showRentDialog();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getFinallyRentalData]);

  useEffect(() => {
    if (rentalsStatusesSuccess && !rentalByIdSuccess) {
      setFilterVisible(true);
    }
  }, [rentalsStatusesSuccess, rentalByIdSuccess]);

  const hideRentDialog = React.useCallback(() => {
    setFinishRentDialogVisibility(false);
    clearRentalsData();
  }, [setFinishRentDialogVisibility, clearRentalsData]);

  const showRentDialog = React.useCallback(() => {
    setFinishRentDialogVisibility(true);
  }, [setFinishRentDialogVisibility]);

  const showToast = useShowToast();

  const finishRentAction = React.useCallback(
    (id, data) => {
      if (Moment(data.endTime).isBefore(currentRentStartTime)) {
        showToast("End time cannot be before start time", "error");
      } else {
        hideRentDialog();
        finishRent(id, data);
      }
    },
    [hideRentDialog, finishRent, currentRentStartTime]
  );

  const startFinishingAction = React.useCallback(
    (rental) => {
      getStationsByCity(rental?.cityId);
      getStationsOnMap(
        ["Stations"],
        ["CHARGE", "VIRTUAL"],
        ["ONLINE", "OFFLINE"],
        [
          "Renting unlocked",
          "Renting locked",
          "Not renting charging",
          "Not renting locked",
          "Not renting unlocked",
          "Low battery or offline",
        ],
        rental?.cityId,
        ""
      );
      rentalsDockList(rental?.cityId);
      getFinallyDataOfRental(rental.id);
      setCurrentRentStartTime(rental.startTime);
    },
    [getStationsByCity, rentalsDockList, getFinallyDataOfRental]
  );

  const handleChangePage = React.useCallback(
    (event, newPage) => {
      changePage(newPage);
    },
    [changePage]
  );

  const renderRentalsList = React.useCallback(
    () => (
      <>
        <Box
          sx={{
            padding: "10px 0",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Tooltip title={strings("descriptions.downloadRentals")}>
            <IconButton size="small" onClick={() => setShowExport(true)}>
              <GetAppIcon />
            </IconButton>
          </Tooltip>

          <Link to={DASHBOARD_RENTALS_GALLERY}>Rentals Gallery</Link>
        </Box>
        <RentalsItem
          finishRentAction={startFinishingAction}
          rentals={rentals}
          rentalsResult={props.rentalsResult}
          handleChangePage={handleChangePage}
          orderProps={orderProps}
          citiesList={props.citiesList}
          setSelectedRentalUser={setSelectedRentalUser}
          setImagePreviewModal={setImagePreviewModal}
          setPreviewImageUrls={setPreviewImageUrls}
        />
      </>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      startFinishingAction,
      rentals,
      props,
      handleChangePage,
      orderProps,
      setShowExport,
    ]
  );

  const pressFilter = () => {
    getRentalsStatuses();
  };

  const hideFilter = () => {
    setFilterVisible(false);
    clearRentalsData();
  };

  const changeSelectorValue = React.useCallback(
    (filter, filterBy) => {
      if (
        filterValues.filter((item) => item.filterBy === filterBy).length > 0
      ) {
        if (!filter.length) {
          setFilterValues(
            filterValues?.filter((item) => item.filterBy !== filterBy)
          );
        } else {
          setFilterValues(
            filterValues.map((item) => {
              if (item.filterBy === filterBy) {
                return { filter, filterBy };
              }
              return item;
            })
          );
        }
      } else {
        setFilterValues([...filterValues, { filter, filterBy }]);
      }
    },
    [filterValues, setFilterValues]
  );

  const removeFilter = React.useCallback(
    (indexValue) => {
      filterProps.setFilterValue(
        filterProps.filterValue.filter((item, index) => index !== indexValue)
      );
    },
    [filterProps]
  );

  const applyFilter = React.useCallback(() => {
    setFilterVisible(false);
    clearRentalsData();

    const hasRating = filterValues.some(
      (f) => f.filterBy === "rating" && f.filter
    );
    const hasOperator = filterValues.some((f) => f.filterBy === "operator");
    let newFilterValues = filterValues;
    if (!hasRating) {
      newFilterValues = filterValues.filter((f) => f.filterBy !== "operator");
    } else if (hasRating && !hasOperator) {
      newFilterValues = [
        ...filterValues,
        { filterBy: "operator", filter: "eq" },
      ];
    }

    filterProps.setFilterValue(newFilterValues);
  }, [filterValues, filterProps, clearRentalsData]);

  const reloadData = React.useCallback(() => {
    getRentals(
      currentPageValue,
      reformatSearch(searchFilter, debouncedSearchTerm),
      orderValue,
      reformatFilter(filterProps.filterValue) +
        (savedCity ? "&" + savedCity : ""),
      pageSize
    );
  }, [
    currentPageValue,
    debouncedSearchTerm,
    pageSize,
    savedCity,
    getRentals,
    searchFilter,
    filterProps.filterValue,
    orderValue,
  ]);

  useEffect(() => {
    reloadData();
  }, [
    currentPageValue,
    debouncedSearchTerm,
    pageSize,
    savedCity,
    getRentals,
    searchFilter,
    filterProps.filterValue,
  ]);
  useEffect(() => {
    if (orderProps?.orderBy && orderProps.order) {
      reloadData();
    }
  }, [orderProps.order, orderProps.orderBy]);
  const content = () => (
    <>
      <SearchBlockWithRefreshBtn
        title={strings("title.rentals")}
        searchValue={searchValue}
        reloadData={reloadData}
        onChange={changeSearch}
        clear={clearSearchValue}
        pressFilter={pressFilter}
        filterProps={filterProps.filterValue}
        removeFilter={removeFilter}
        searchFilter={searchFilter}
        setSearchFilter={setSearchFilter}
        searchDataOptions={searchDataOptions}
      />
      {rentals?.length > 0 ? (
        <div className={"dashboardList"}>{renderRentalsList()}</div>
      ) : (
        <p className={"emptyResultText"}>{strings("message.noRentals")}</p>
      )}
      <RentalFilter
        apply={applyFilter}
        cancel={hideFilter}
        visible={filterVisible}
        hideFilter={hideFilter}
        changeSelectorValue={changeSelectorValue}
        citiesList={citiesList}
        filterProps={filterValues}
        statuses={rentalsStatuses}
      />
      <InputDialogWithMap
        title={strings("message.finishTrip")}
        visibility={finishRentDialogVisibility}
        hideDialog={hideRentDialog}
        positiveAction={finishRentAction}
        negativeAction={hideRentDialog}
        stationsList={props.stationsByCity}
        docksList={props.rentalDocks}
        rentalData={finallyRentalData}
        disablePast={false}
      />

      <RentalModal
        clearRental={clearRental}
        visible={
          !!(
            props.rentalVehiclesSuccess &&
            props.getStationsByCitySuccess &&
            props.rentalDocksSuccess &&
            props.rentalUsersSuccess &&
            props.rentalsStatusesSuccess
          )
        }
        rental={props.rental}
        vehicles={props.rentalVehicles}
        stations={props.stationsByCity}
        docks={props.rentalDocks}
        users={props.rentalUsers}
        updateRental={props.updateRental}
        statuses={rentalsStatuses}
      />
      <ImagePreviewModal
        previewImageUrls={previewImageUrls}
        visible={imagePreviewModal}
        setImagePreviewModal={setImagePreviewModal}
        setPreviewImageUrls={setPreviewImageUrls}
      />
      {showExport && (
        <RentalsExportBox
          onSuccess={() => setShowExport(false)}
          onError={() => setShowExport(false)}
          onClose={() => setShowExport(false)}
          rentals={rentals}
          rentalsResult={props.rentalsResult}
          searchFilter={searchFilter}
          searchValue={debouncedSearchTerm}
          orderValue={orderValue}
        />
      )}
    </>
  );

  const loading = () => <Loader />;

  return (
    <div className={"dashboardContent"}>
      {getRentalsSuccess ? content() : loading()}
    </div>
  );
}

const mapStateToProps = ({
  rentals: {
    rentals,
    rentalsResult,
    getRentalsSuccess,
    rentalByIdSuccess,
    rental,
    rentalVehiclesSuccess,
    rentalDocksSuccess,
    rentalVehicles,
    rentalDocks,
    rentalUsers,
    rentalUsersSuccess,
    updateRentalSuccess,
    rentalsStatusesSuccess,
    rentalsStatuses,
    finallyRentalData,
    getFinallyRentalData,
    postFinishRentalSuccess,
    rentalsForExcel,
    getRentalsForExcelSuccess,
  },
  cities: { citiesList, savedCity },
  screen: { pageSize, passedParams, currentPageValue },
  stations: { getStationsByCitySuccess, stationsByCity },
}) => ({
  rentals,
  rentalsForExcel,
  rentalsResult,
  getRentalsSuccess,
  getRentalsForExcelSuccess,
  rentalByIdSuccess,
  rental,
  rentalVehiclesSuccess,
  rentalDocksSuccess,
  rentalVehicles,
  rentalDocks,
  rentalUsers,
  rentalUsersSuccess,
  updateRentalSuccess,
  citiesList,
  savedCity,
  pageSize,
  rentalsStatusesSuccess,
  rentalsStatuses,
  finallyRentalData,
  getFinallyRentalData,
  postFinishRentalSuccess,
  getStationsByCitySuccess,
  stationsByCity,
  passedParams,
  currentPageValue,
});

const mapDispatchToProps = {
  clearRental,
  finishRent,
  rentalsDockList,
  rentalsVehiclesList,
  rentalsUserList,
  updateRental,
  getRentals,
  getRentalsStatuses,
  clearRentalsData,
  getFinallyDataOfRental,
  getStationsByCity,
  getLinkedStationsByCity,
  emptyPassedParams,
  getRentalById,
  getStationsOnMap,
};

export default connect(mapStateToProps, mapDispatchToProps)(RentalsContainer);
